import { HttpParams } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '@agilox/common';
import { ListRequestParams } from '../interfaces/list-request-params.interface';

/**
 * New params builder to handle the updated syntax of the new backend.
 * The idea is to expand this class as we go and add functionality once the need arises.
 */
export class HttpsParamsBuilderNew {
	static buildParameters(params: ListRequestParams): HttpParams {
		const { pageNumber, pageSize, sort, include, filter } = params || {};
		let stringParam = '';

		if (pageNumber) {
			stringParam += `page[number]=${pageNumber}`;
		}

		if (pageSize) {
			stringParam += `${stringParam ? '&' : ''}page[size]=${pageSize}`;
		}

		if (sort) {
			stringParam += `${stringParam ? '&' : ''}sort=${encodeURIComponent(sort)}`;
		}

		if (include) {
			stringParam += `${stringParam ? '&' : ''}include=${encodeURIComponent(include)}`;
		}

		if (filter) {
			stringParam += this.objectToParams(filter, 'filter');
		}

		// Strip first '&' if present (when filter is the first param)
		if (stringParam.length > 0 && stringParam.startsWith('&')) {
			stringParam = stringParam.substring(1);
		}

		return new HttpParams({
			fromString: stringParam,
			encoder: new CustomHttpUrlEncodingCodec(),
		});
	}

	private static objectToParams(data: object, key: string): string {
		let tempString = '';
		Object.entries(data).forEach(([propertyKey, value]) => {
			if (value && !Array.isArray(value)) {
				tempString += `&${key}[${propertyKey}]=${encodeURIComponent(value)}`;
			}
			if (Array.isArray(value) && value.length > 0) {
				tempString += this.arrayToParams(key, propertyKey, value);
			}
		});
		return tempString;
	}

	private static arrayToParams(key: string, propertyKey: string, data: any[]): string {
		return `&${key}[${propertyKey}]=${data.map((value) => encodeURIComponent(value)).join(',')}`;
	}
}
